import { handleActions } from "redux-actions";

import { setConfigCiTestCasesStatuses } from "./actions";

const initialState = {
    isLoadingConfigCiTestCasesStatuses: false,
    codes: [],
    configCiTestCasesStatuses: {}
};

export const configCiTestCasesStatusesReducer = handleActions(
    {
        [setConfigCiTestCasesStatuses]: (state, { payload }) => ({
            ...state,
            ...payload
        })
    },
    initialState
);
